import toRadio from './toRadio';
import toText from './toText';
import toTextArea from './toTextArea';
import toTextList from './toTextList';
import toTable from './toTable';
import toSelect from './toSelect';
import toCheckboxes from './toCheckboxes';

export default (props) => {
  const { to, ...rest } = props;
  switch (to) {
    case 'radio':
      toRadio(rest);
      break;
    case 'checkboxes':
      toCheckboxes(rest);
      break;
    case 'text':
      toText(rest);
      break;
    case 'textArea':
      toTextArea(rest);
      break;
    case 'textList':
      toTextList(rest);
      break;
    case 'table':
      toTable(rest);
      break;
    case 'select':
      toSelect(rest);
      break;
    default:
      break;
  }
};



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/changeQuestionType/index.js